module.exports = __webpack_public_path__ + "static/img/A6107.a5e6b58a.png";